 function LocationMap({eventInfo}:any) {
     return (
         <>
         <section className="location-sec sec-padding" data-scroll-index="6">
        <div className="container">
            <div className="sec-title">
                <span className="icon-inner wow flipInY" data-wow-duration="300ms"><span className="fa-stack"><i className="fa rhex fa-stack-2x"></i><i className="fa  fa-map-pin fa-stack-1x"></i></span></span>
                <h3 className="wow fadeInRight" data-wow-duration="500ms">Venue </h3>
            </div> {/* <!--sec-title end--> */}
            <div className="location-sec-details">

                <div className="row pt-2">
                    <div className="col-lg-6 col-md-6 col-sm-6">
                    <div className="location-sec-address">
                        <ul>
                            <li style={{fontWeight:"bold"}}> {eventInfo.venuename}</li>
                            <li> {eventInfo.addressline1}</li>
                            <li> {eventInfo.addressline2}</li>
                            <li> {eventInfo.city} - {eventInfo.pincode}</li>
                            <li> {eventInfo.state}</li>
                               </ul>
                        </div>
                    </div><div className="col-lg-6 col-md-6 col-sm-6">
                    <iframe src={eventInfo.maplink}  width="100%"   height="100%"  loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                      
                    </div>
                </div>
            </div> 
        </div>
    </section>
         </>
     );
 }

 export {LocationMap}